import React from 'react';
import { Quote } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Founders = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative py-32 px-6 bg-gradient-to-b from-[#1e3a8a] to-[#2563eb]">
        <div className="max-w-5xl mx-auto text-center text-white">
          <h1 className="text-6xl font-bold mb-6">Founder's Desk</h1>
          <p className="text-2xl text-gray-100">
            Leadership Vision for a Sustainable Future
          </p>
        </div>
      </section>

      {/* Message Section */}
      <section className="py-24 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="bg-gray-50 rounded-3xl p-12 md:p-16">
            <div className="flex justify-center mb-12">
              <Quote className="h-16 w-16 text-[#fbbf24]" />
            </div>
            
            <h2 className="text-4xl font-bold text-center text-[#1e3a8a] mb-12">
              A Message from the Founders
            </h2>

            <div className="prose prose-xl max-w-4xl mx-auto text-gray-700">
              <p className="text-xl leading-relaxed mb-6">
                Welcome to BRISE.
              </p>
              
              <p className="text-xl leading-relaxed mb-6">
                We stand at a critical juncture in history where the energy choices we make today 
                will define the world we leave for tomorrow. When we established Bharat Renewable 
                Infrastructure & Solar Energy, the goal was not just to build a company, but to create 
                an institution dedicated to national self-reliance and global sustainability.
              </p>
              
              <p className="text-xl leading-relaxed mb-6">
                Whether it is a utility-scale solar plant powering a city or a rooftop installation 
                for a local business, we approach every project with the same level of precision and 
                dedication. We are committed to making India a global hub for renewable infrastructure.
              </p>
              
              <p className="text-xl leading-relaxed mb-8">
                Thank you for trusting us to power your future.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Founders Section */}
      <section className="py-24 px-6 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl font-bold text-center text-[#1e3a8a] mb-16">
            Meet Our Founders
          </h2>
          
          <div className="grid md:grid-cols-2 gap-16 max-w-5xl mx-auto">
            {/* Founder 1 - Pulkit Garg */}
            <div className="text-center">
              <div className="relative mb-8 inline-block">
                <div className="w-72 h-72 rounded-3xl overflow-hidden mx-auto shadow-2xl border-4 border-[#fbbf24]">
                  <img 
                    src="https://customer-assets.emergentagent.com/job_design-launchpad-3/artifacts/0vdl1rrl_IMG_7014.jpg" 
                    alt="Pulkit Garg" 
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="absolute -bottom-4 left-1/2 transform -translate-x-1/2 bg-[#fbbf24] px-6 py-2 rounded-full shadow-lg">
                  <span className="text-[#1e3a8a] font-bold text-sm">Co-Founder</span>
                </div>
              </div>
              <h3 className="text-3xl font-bold text-[#1e3a8a] mb-2">Pulkit Garg</h3>
              <p className="text-xl text-gray-600 mb-4">Founder & Director</p>
              <p className="text-gray-700 leading-relaxed">
                Visionary leader driving BRISE's mission to establish India as a global renewable 
                energy hub through innovation and sustainable practices.
              </p>
            </div>

            {/* Founder 2 - Abhishek Garg */}
            <div className="text-center">
              <div className="relative mb-8 inline-block">
                <div className="w-72 h-72 rounded-3xl overflow-hidden mx-auto shadow-2xl border-4 border-[#fbbf24]">
                  <img 
                    src="https://customer-assets.emergentagent.com/job_design-launchpad-3/artifacts/mrzaocgz_IMG_7016.jpg" 
                    alt="Abhishek Garg" 
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="absolute -bottom-4 left-1/2 transform -translate-x-1/2 bg-[#fbbf24] px-6 py-2 rounded-full shadow-lg">
                  <span className="text-[#1e3a8a] font-bold text-sm">Co-Founder</span>
                </div>
              </div>
              <h3 className="text-3xl font-bold text-[#1e3a8a] mb-2">Abhishek Garg</h3>
              <p className="text-xl text-gray-600 mb-4">Founder & Director</p>
              <p className="text-gray-700 leading-relaxed">
                Strategic leader committed to delivering world-class EPC solutions and manufacturing 
                excellence for India's clean energy transition.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Vision Statement */}
      <section className="py-24 px-6">
        <div className="max-w-5xl mx-auto">
          <div className="bg-[#1e3a8a] text-white rounded-3xl p-12 md:p-16 text-center">
            <h2 className="text-4xl font-bold mb-8">Our Commitment</h2>
            <p className="text-2xl leading-relaxed">
              "Building not just solar infrastructure, but a legacy of sustainable energy 
              independence for generations to come."
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Founders;
